<template>
  <v-card flat class="pa-6">
    <div class="d-flex justify-end">
      <v-btn class="icon mr-4" @click="save"> <v-icon>$sl-content-paper-edit</v-icon>SPARA UTKAST</v-btn>
      <v-btn class="icon" color="secondary" @click="showPublishModal"> <v-icon>$sl-check</v-icon>PUBLICERA</v-btn>
    </div>
    <h5>TEXT PÅ FÖRSTASIDAN</h5>
    <v-textarea outlined rows="4" v-model="instructions.content"></v-textarea>

    <div class="pb-4 d-flex justify-space-between">
      <h5>AVSNITT</h5>
      <v-btn class="icon" color="secondary" @click="addSection(0)">
        <v-icon>$sl-add</v-icon>LÄGG TILL AVSNITT HÄR</v-btn
      >
    </div>
    <transition-group name="list" tag="div">
      <div v-for="(section, index) in sections" :key="section.id" class="list-item">
        <InsturctionSection
          :section="section"
          :index="index"
          :total="instructions.sections.length"
          @moveUp="moveUp(index)"
          @moveDown="moveDown(index)"
          @delete="deleteSection(index)"
          @add="addSection(index + 1)"
        />
      </div>
    </transition-group>
    <v-dialog v-model="publishDialog" max-width="900px">
      <PublishModal @close="publishDialog = false" @publish="publish" />
    </v-dialog>
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {RulesMixin} from '@/components/mixins'
import InsturctionSection from '@/components/admin/instructions/InsturctionSection.vue'
import PublishModal from '@/components/admin/instructions/PublishModal.vue'

export default {
  name: 'EditInstructions',

  components: {
    InsturctionSection,
    PublishModal
  },

  data: () => ({
    instructions: {},
    sections: [],
    publishDialog: false
  }),

  mixins: [RulesMixin],

  created() {
    this.init()
  },

  methods: {
    init() {
      API.getInstructions(1).then(({data}) => {
        this.instructions = data
        this.sections = data.sections.items || []
      })
    },
    save() {
      const data = {...this.instructions}
      data.sections = {items: this.sections}
      API.updateInstructions(1, data).then(response => {
        this.$events.fire('showSuccess', 'Sparad')
      })
    },
    showPublishModal() {
      this.publishDialog = true
    },
    publish(commit) {
      this.publishDialog = false
      const data = {...this.instructions}
      data.sections = {items: this.sections}
      API.updateInstructions(1, data)
        .then(() => {
          return API.publishInstructions(commit)
        })
        .then(() => {
          this.$events.fire('showSuccess', 'Publicerad')
        })
    },
    addSection(index) {
      const newSection = {
        text: '',
        header: 'Nytt avsnitt',
        id: Math.random().toString(36).substr(2, 9)
      }
      this.sections.splice(index, 0, newSection)
    },
    moveUp(index) {
      const temp = this.sections[index - 1]
      this.$set(this.sections, index - 1, this.sections[index])
      this.$set(this.sections, index, temp)
    },
    moveDown(index) {
      const temp = this.sections[index + 1]
      this.$set(this.sections, index + 1, this.sections[index])
      this.$set(this.sections, index, temp)
    },
    deleteSection(index) {
      this.sections.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.list-enter-active,
.list-leave-active {
  transition: all 0.3s;
}
.list-enter /* .list-leave-active до версии 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}

.list-leave-to,
.list-leave-active {
  opacity: 0;
  transform: translateX(300px);
}
.list-move {
  transition: transform 1s;
}
</style>